export const coachReviewStatus: Record<string, string> = {
  pending: 'Requested',
  in_progress: 'In progress',
  completed: 'Feedback received',
  failed: 'Could not finish',
  stalled: 'Taking longer than usual',
}
